<template>
    <div class="d-flex">
        <b-button v-if="params.data.type !== 'INVOICE_VARIABLES'" variant="default" class="mr-2" title="Clone"
            @click="clone"><font-awesome-icon :icon="['fas', 'copy']" /></b-button>
        <b-button title="Edit" @click="editForm" class="mr-2" variant="default">
            <font-awesome-icon :icon="['fas', 'edit']"></font-awesome-icon>
        </b-button>
        <b-button title="Delete" v-if="!params.data.is_limited" @click="$bvModal.show(modalId)" variant="default">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <b-button v-if="params.data.is_limited && params.data.type === 'HOUSEKEEPER'" variant="default" class="mr-2"
            title="Reset" @click="$bvModal.show(resetModalId)"><font-awesome-icon
                :icon="['fas', 'arrow-rotate-left']" /></b-button>
        <modal :id="modalId" title="Delete form" @ok="handleDeleteClick">
            Are you sure you want to delete {{ params.data.title }} ?
        </modal>
        <modal :id="resetModalId" title="Reset checklist" @ok="reset">
            Are you sure you want to reset {{ params.data.title }} ?
        </modal>
    </div>
</template>

<script>
import modal from '../../generic/modal/modal.vue';
export default {
    components: { modal },
    computed: {
        modalId() {
            return `delete-hosted-form-${this.params.data.id}`;
        },
        resetModalId() {
            return `reset-hosted-form-${this.params.data.id}`;
        },
    },
    methods: {
        handleDeleteClick() {
            this.params.delete && this.params.delete(this.params.data.id);
        },
        editForm() {
            this.$router.push(`/app/hosted-form/${this.params.data.id}/edit/`);
        },
        clone() {
            this.params.clone && this.params.clone(this.params.data.id);
        },
        reset() {
            this.params.reset && this.params.reset(this.params.data.id);
        },
    },
};
</script>

<style></style>